import { render, staticRenderFns } from "./HuaxianGeneralSituation.vue?vue&type=template&id=5f07d22d&scoped=true&"
import script from "./HuaxianGeneralSituation.vue?vue&type=script&lang=js&"
export * from "./HuaxianGeneralSituation.vue?vue&type=script&lang=js&"
import style0 from "./HuaxianGeneralSituation.vue?vue&type=style&index=0&id=5f07d22d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f07d22d",
  null
  
)

export default component.exports